/**
 * Location entity class
 */

/**
 * LocationFactory
 * returns Location entity class
 *
 * @class LocationFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Location} class
 *
 * @ngdoc factory
 * @name mwApp.factory:LocationFactory
 */
/* @ngInject */
export default function LocationFactory ($http, alertLiteSvc, Entity) {
  /* === Location class === */

  /**
   * Location model
   *
   * @class Location
   * @classdesc Location model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [Object] - initial object, containing Location entity fields
   * @return {models.Location} PaymentSystem entity
   */
  function Location () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Location.prototype = Object.create(Entity.prototype)
  Location.prototype.constructor = Location

  /* === Location instance methods & fields === */

  Object.assign(Location.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Location#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String
    }
  })

  /* === Location static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Location, Entity)
  Location._name = 'Location'
  Location._publicName = 'Location'
  Location.init()

  return Location
}
